import React from 'react'
import "./Nav.scss"
export function Nav() {
  return (
    <div className='nav_bar'>
        <div className='logo'>
            <img src='/QRemixLogo.png' alt='Generador de QR gratuito'/>
        </div>
    </div>
  )
}
